/** The ledger of one account, optionally over a window — where a balance came from. */
export const ledgerPath = (accountId: string, window: { from?: string | null; to?: string | null } = {}) => {
  const q = new URLSearchParams();
  if (window.from) q.set('from', window.from.slice(0, 10));
  if (window.to) q.set('to', window.to.slice(0, 10));
  const s = q.toString();
  return `/app/finance/ledger/${accountId}${s ? `?${s}` : ''}`;
};
